import { MSFilterItemSize } from "@models/model-screener/enums/filterValues";
import { Slider, SliderProps } from "@mui/material";
import React from "react";
import { useMemo } from "react";

interface SHSliderProps extends SliderProps {
  min: number;
  max: number;
  value: number | number[];
  step?: number | null;
  size: MSFilterItemSize;
}
export const SHSlider = React.forwardRef(
  ({ min, max, step, value, size, ...props }: SHSliderProps, ref: any): JSX.Element => {
    const marks = useMemo(() => {
      const interval = (max - min) / 4;
      return Array.from({ length: 5 }, (_, i) => {
        const val = parseFloat((min + i * interval).toFixed(2));
        return { value: val };
      });
    }, [min, max]);

    return (
      <Slider
        ref={ref}
        size={size}
        value={value}
        step={step}
        marks={marks}
        min={min}
        max={max}
        {...props}
      />
    );
  },
);
